import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import DashboardInfoCard from '../Dashboard/Cards/DashboardInfoCards';
import LoadingUI from '../../components/UI/Loading/LoadingUI';
import { moveScroll } from '../../helpers';
import { buscarInformacoesDashboardService } from '../../services';
import { CardsContainer, CardsRoot } from './ConsultarEstatisticas.styles';
import { initializePageAction } from '../../store/theme.actions';


function ConsultarEstatisticasPage() {
  const dispatch = useDispatch();

  const [cardsInfos, setCardsInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const buscarInformacoesInicias = useCallback(async () => {
    try {
      setLoading(true);
      const response = await buscarInformacoesDashboardService();
      setCardsInfo(response.data);
    } catch (e) {
      // Nenhum tratamento...
    } finally {
      setLoading(false);
    }
  }, []);

  // Busca informações iniciais da tela.
  useEffect(() => {
    moveScroll();
    buscarInformacoesInicias().then();
  }, [buscarInformacoesInicias]);

  // Altera o título da página.
  useEffect(() => {
    dispatch(initializePageAction('Consultar Estatísticas'));
  }, [dispatch]);

  return (
    <>
      <LoadingUI show={loading} />
      <CardsContainer>
        <CardsRoot>
          <DashboardInfoCard type="borderos" count={cardsInfos?.qtdeBorderos || 0} />
          <DashboardInfoCard type="clientes" count={cardsInfos?.novosClientes || 0} />
        </CardsRoot>
        <CardsRoot>
          <DashboardInfoCard type="acordos" count={cardsInfos?.acordosFirmados || 0} />
          <DashboardInfoCard type="processos" count={cardsInfos?.processosAtivos || 0} />
        </CardsRoot>
      </CardsContainer>
    </>
  );
}

export default ConsultarEstatisticasPage;
